import { ALL_VEHICLES_QUERY } from "../../../graphql/Vehicles/Vehicles.graphql";
import { ALL_INSPECTION_MASTER_QUERY } from "../../../graphql/InspectionMaster/InspectionMaster.graphql";
import { ALL_SYSTEM_CODES_QUERY } from "../../../graphql/SystemCodes/SystemCodes.graphql";
import { ALL_VENDORS_QUERY } from "../../../graphql/Vendors/Vendors.graphql";
import { ALL_INVENTORY_ON_HAND_QUERY } from "../../../graphql/Items/InventoryOnHand.graphql";

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

export default {
  name: "Fleet Management",
  label: "Fleet",
  icon: "truck",
  permissions: ["FLEET", "MECH"],
  active: location => location.pathname.includes("fleet"),
  links: [
    {
      name: "Inventory Processing",
      links: [
        {
          name: "Item On-Hand Inquiry",
          to: "/inventory/inventory-on-hand",
          query: ALL_INVENTORY_ON_HAND_QUERY,
          filters: "INVENTORY_ON_HAND_FILTERS"
        }
      ]
    },
    {
      name: "Setup",
      permissions: ["FLEET", "ADMIN", "FIN"],
      links: [
        {
          name: "Inspections",
          to: "/fleet/inspection-masters",
          query: ALL_INSPECTION_MASTER_QUERY,
          filters: "INSPECTION_MASTER_FILTERS"
        },
        {
          name: "System Codes",
          to: "/fleet/system-codes",
          query: ALL_SYSTEM_CODES_QUERY
        },
        {
          name: "Vendors",
          to: "/fleet/vendors",
          query: ALL_VENDORS_QUERY,
          filters: "VENDOR_FILTERS"
        }
      ]
    },
    {
      name: "Vehicles Processing",
      links: [
        {
          name: "Vehicles",
          to: "/fleet/vehicles",
          query: ALL_VEHICLES_QUERY
        },
        {
          name: "Vehicle Status Processing",
          to: "/fleet/vehicle-status-processing/available",
          query: ALL_SYSTEM_CODES_QUERY
        }
      ]
    },
    {
      name: "Work Order Processing",
      links: [
        {
          name: "Work Orders",
          to: "/fleet/work-orders",
          filters: "WORK_ORDERS_FILTERS"
        },
        {
          name: "Work Order Approval and Posting",
          to: "/fleet/work-orders-processing"
        }
      ]
    },
    {
      name: "Reports",
      links: [
        {
          name: "Open Work Order Report",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=WorkOrders`
        },
        {
          name: "Scheduled Maintenance Report",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=Vehicle%20Inspections%20Due%20Report`
        }
      ]
    }
  ]
};
